import { Range } from '@dreryk/watermelon';

export enum DateFilterType {
   TODAY = 'today',
   DAY = 'day',
   RANGE = 'range',
}

export type DateFilter = {
   type: DateFilterType;
   range: Range<Date>;
};
